import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: null,
  message: null,
};

const publishProgramSlice = createSlice({
  name: 'publishProgram',
  initialState,
  reducers: {
    PUBLISH_PROGRAM: state => ({ ...state, isLoading: true }),
    PUBLISH_PROGRAM_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      message: payload.message,
    }),
    PUBLISH_PROGRAM_FAIL: (state, { payload }) => ({
      ...state,
      isLoading: false,
      message: payload.message,
    }),
    RESET_STATE: () => ({ ...initialState }),
  },
});

export const {
  PUBLISH_PROGRAM,
  PUBLISH_PROGRAM_FAIL,
  PUBLISH_PROGRAM_SUCCESS,
  RESET_STATE,
} = publishProgramSlice.actions;

export const publishProgramSelector = state => state.publishProgram;

export default publishProgramSlice.reducer;
